import Product from "../product/Product"
import products from "../data"
import './ProductList.css';
const ProductList = () =>
{
  return(
    <div className="pl">
      <div className="pl-texts">
        <h1 className="pl-title">Projects </h1>
        <p className="pl-desc">These are some of the interesting things that I have build during my career and education</p>
      </div>
      <div className="pl-list">
        {products.map((item) =>
        (
          <Product key={item.id} img={item.img} link={item.link} title = {item.title}/>
        ))}
      </div>
      </div>
    )
  }
  export default ProductList